import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col" }
const _hoisted_3 = { for: "pw" }
const _hoisted_4 = { for: "pwConfirm" }
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { for: "userNameRight" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = { for: "restrPublication" }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = { for: "imageUploadPermission" }
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = { class: "p-d-flex p-flex-md-row" }
const _hoisted_18 = { class: "p-col-12 p-mb-2 p-mr-4 p-ml-1" }
const _hoisted_19 = { class: "p-d-flex p-flex-md-row" }
const _hoisted_20 = { class: "p-col-12 p-mb-2 p-mr-4" }
const _hoisted_21 = { for: "acceptLicense" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" * ")
const _hoisted_24 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_25 = { class: "p-field p-col" }
const _hoisted_26 = { class: "p-field p-col" }
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_form = _resolveComponent("profile-form")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.state !== 'success')
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "p-d-flex p-jc-center"
        }, {
          title: _withCtx(() => [
            _createVNode("h2", null, _toDisplayString(_ctx.$t('login.create_account')), 1)
          ]),
          content: _withCtx(() => [
            _createVNode(_component_profile_form, {
              disabled: ['submitted', 'success'].includes(_ctx.state),
              user: _ctx.user,
              onChangeUser: _ctx.updateUserInfo
            }, null, 8, ["disabled", "user", "onChangeUser"])
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_Card, {
              disabled: _ctx.state === 'submitted'
            }, {
              title: _withCtx(() => [
                _createVNode("h3", null, _toDisplayString(_ctx.$t('login.password_set')), 1)
              ]),
              content: _withCtx(() => [
                _createVNode("div", _hoisted_1, [
                  _createVNode("div", _hoisted_2, [
                    _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('login.password_form')) + " *", 1),
                    _createVNode(_component_InputText, {
                      id: "pw",
                      class: "p-inputtext-sm",
                      type: _ctx.showPw ? 'text' : 'password',
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event)),
                      readonly: "",
                      onfocus: "this.removeAttribute('readonly');"
                    }, null, 8, ["type", "modelValue"])
                  ]),
                  _createVNode("div", {
                    class: ["p-field p-col", {'pError':_ctx.password.length > 1 && (!_ctx.passwordValid || !_ctx.passwordsMatch)}]
                  }, [
                    _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('login.password_confirm')) + " *", 1),
                    _createVNode(_component_InputText, {
                      id: "pwConfirm",
                      class: "p-inputtext-sm",
                      type: _ctx.showPw ? 'text' : 'password',
                      modelValue: _ctx.passwordConfirm,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.passwordConfirm = $event))
                    }, null, 8, ["type", "modelValue"])
                  ], 2)
                ])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_Card, {
              disabled: _ctx.state === 'submitted'
            }, {
              title: _withCtx(() => [
                _createVNode("h3", null, _toDisplayString(_ctx.$t('login.privacy')), 1)
              ]),
              content: _withCtx(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("label", _hoisted_7, [
                      _createVNode("b", null, _toDisplayString(_ctx.$t('login.userNameRight')) + " *", 1)
                    ]),
                    _hoisted_8,
                    _createVNode("p", null, _toDisplayString(_ctx.$t('login.userNameRightRecommandation')), 1),
                    _createVNode(_component_Dropdown, {
                      id: "userNameRight",
                      modelValue: _ctx.user.userNameRight,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.user.userNameRight = $event)),
                      filter: true,
                      filterPlaceholder: _ctx.$t('search'),
                      options: _ctx.booleanAnonymousOptions,
                      placeholder: _ctx.$t('choose_dropdown'),
                      class: "p-mb-2",
                      optionLabel: "LABEL",
                      optionValue: "ID"
                    }, null, 8, ["modelValue", "filterPlaceholder", "options", "placeholder"])
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode("label", _hoisted_11, [
                      _createVNode("b", null, _toDisplayString(_ctx.$t('login.restrPublication')) + " *", 1)
                    ]),
                    _hoisted_12,
                    _createVNode("p", null, _toDisplayString(_ctx.$t('login.restrPublicationRecommandation')), 1),
                    _createVNode(_component_Dropdown, {
                      id: "restrPublication",
                      modelValue: _ctx.user.restrPublication,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.user.restrPublication = $event)),
                      filter: true,
                      filterPlaceholder: _ctx.$t('search'),
                      options: _ctx.booleanOptions,
                      placeholder: _ctx.$t('choose_dropdown'),
                      class: "p-mb-2",
                      optionLabel: "LABEL",
                      optionValue: "ID"
                    }, null, 8, ["modelValue", "filterPlaceholder", "options", "placeholder"])
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode("label", _hoisted_15, [
                      _createVNode("b", null, _toDisplayString(_ctx.$t('login.imageUploadPermission')) + " *", 1)
                    ]),
                    _hoisted_16,
                    _createVNode("p", null, _toDisplayString(_ctx.$t('login.imageUploadPermissionRecommandation')), 1),
                    _createVNode(_component_Dropdown, {
                      id: "imageUploadPermission",
                      modelValue: _ctx.user.imageUploadPermission,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.user.imageUploadPermission = $event)),
                      options: _ctx.imageUploadPermissionOptions,
                      optionLabel: "LABEL",
                      optionValue: "ID",
                      placeholder: _ctx.$t('choose_dropdown'),
                      filter: true,
                      filterPlaceholder: _ctx.$t('search'),
                      class: "p-mb-2"
                    }, null, 8, ["modelValue", "options", "placeholder", "filterPlaceholder"])
                  ]),
                  _createVNode("div", {
                    class: {'pError': _ctx.state !== 'submitted' && _ctx.acceptLicense === false}
                  }, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('login.privacy_infospecies')) + " " + _toDisplayString(_ctx.$t('login.privacy_swisslichens')), 1)
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode(_component_Checkbox, {
                          id: "acceptLicense",
                          modelValue: _ctx.acceptLicense,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.acceptLicense = $event)),
                          binary: true,
                          class: [{'pError': _ctx.state !== 'submitted' && _ctx.acceptLicense === false}, "p-m-1"]
                        }, null, 8, ["modelValue", "class"]),
                        _createVNode("label", _hoisted_21, [
                          _createTextVNode(_toDisplayString(_ctx.$t('login.i_accept')) + " ", 1),
                          _createVNode("a", {
                            href: _ctx.$t('login.deontology_infospecies'),
                            target: "_blank"
                          }, "Info Species", 8, ["href"]),
                          _hoisted_22,
                          _createVNode("a", {
                            href: `${_ctx.publicPath}Nutzungsbedingungen_SwissLichens_SwissFungi.pdf`,
                            target: "_blank"
                          }, "SwissLichens", 8, ["href"]),
                          _hoisted_23
                        ])
                      ])
                    ])
                  ], 2)
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _createVNode(_component_Button, {
                      class: "p-button-info",
                      onClick: _ctx.toLogin,
                      label: _ctx.$t('login.back'),
                      disabled: _ctx.state === 'submitted'
                    }, null, 8, ["onClick", "label", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_26, [
                    _createVNode(_component_Button, {
                      class: "p-button-success",
                      disabled: !_ctx.valid,
                      onClick: _ctx.register,
                      label: _ctx.$t('login.create_account')
                    }, null, 8, ["disabled", "onClick", "label"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        (_ctx.state === 'success')
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              severity: "success",
              closable: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.register_success')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.state === 'success')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "p-button-success",
              onClick: _ctx.toLogin,
              label: _ctx.$t('login.login')
            }, null, 8, ["onClick", "label"]))
          : _createCommentVNode("", true),
        (_ctx.state === 'error')
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 2,
              severity: "error",
              closable: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.register_error')) + " ", 1),
                _hoisted_27,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.errors, (error, key) => {
                  return (_openBlock(), _createBlock("span", { key: key }, [
                    _createTextVNode(" '" + _toDisplayString(_ctx.$t('login.'+key)) + "' -- " + _toDisplayString(error), 1),
                    _hoisted_28
                  ]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}